import HeaderSelect, { HeaderSelectType } from '../header-select/HeaderSelect';
import React, { useContext } from 'react';
import styles from './HeaderControls.module.scss';
import { AppContext } from '../../context/AppContext';
import plansData from '../../plansData';
import axios from 'axios';

const HeaderControls = () => {
  const appContext = useContext(AppContext);

  var link = axios.defaults.baseURL;
  return (
    <>
      <div className={styles.headerControls}>

        <p>
        Use this directory to find health care professionals in your area.
        </p>

        <p>
          <b>To use the search tool below:</b>
        </p>

        <ul style={{ listStyleType: 'disc', marginLeft: '20px' }}>
          <li>Select the green tab that best fits your search</li>
          <li>Choose a Specialty or enter a keyword or provider name to narrow your search</li>
          <li>Enter your zip code and the distance from your zip code you are able to travel to visit a provider</li>
          <li>Click the search icon on the right of the search information</li>
        </ul>

        <p>
        Note: You may search all providers by choosing "All Specialties" and leaving the keyword fields blank. You may search all locations in Alabama by leaving the zipcode and distance fields blank.
        </p>

        <p><b>All providers in this directory accept Medicare and Medicaid. For more information on the directory, review the directory preamble: </b>
            <br />
          <span> <a href="https://simpra.com/2026-provider-directory-preamble-of-alabama" className="disclaimer-link-2">
            {`${new Date().getFullYear()}`} Simpra Advantage Provider and Pharmacy Directory Network Introduction
          </a>
          </span>
          <br />
          <span>
            <a href="https://simpra.com/2027-provider-directory-preamble/" className="disclaimer-link-2">
           2027 Simpra Advantage Provider and Pharmacy Directory Network Introduction
          </a>
            {/* 2027 Simpra Advantage Provider and Pharmacy Directory Introduction -- COMING SOON */}
          </span> 
        </p>

        <p><b>To download the current Provider Directory, click here: </b>
          <br />
              <a href={`${link}fulldirectory/print`} target='_blank' rel='noreferrer' className="disclaimer-link-2">
              {`${new Date().getFullYear()}`} Simpra Advantage Provider Directory Network / All PPO Plans
          </a>
          <br />
          <span>2027 Simpra Advantage Provider Directory Network / All PPO Plans -- COMING SOON</span>
        </p>

        <span style={{ marginTop: 15 }}>Para español, use Google Chrome y Google Translate</span>
      </div>
    </>
  );
};

export default HeaderControls;
